import React, { useState, useEffect } from 'react';
import { Portal } from 'react-portal';

import BotStore from '@src/store';

import GeneralNodes from '@src/containers/Overlays/GeneralNodes/GeneralNodes';
import GeneralNodesV2 from './GeneralNodesV2';

export default function GeneralNodesSwitch(props) {
  const isSelfServe = BotStore.getSelfServeLayout();

  return isSelfServe ? (
    <GeneralNodesV2 {...props} />
  ) : (
    <Portal>
      <GeneralNodes {...props} />
    </Portal>
  );
}
